import React, { useEffect, useState } from "react";
import { PageHeader } from "./Pengumuman";
import { PhoneCall, Shield, Siren, Flame, Ambulance, Zap, Droplet, UserCog, Phone, Plus, Edit3, Trash2 } from "lucide-react";
import { Card, CardContent } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../components/ui/dialog";
import { kontakAPI } from "../lib/api";
import { useApp } from "../context/AppContext";
import { toast } from "sonner";

const ICON_MAP = { UserCog, Shield, Siren, Flame, Ambulance, Zap, Droplet, Phone, PhoneCall };
const ICON_OPTIONS = ["UserCog", "Shield", "Siren", "Flame", "Ambulance", "Zap", "Droplet", "Phone", "PhoneCall"];
const emptyForm = { nama: "", nomor: "", kategori: "Pengurus", icon: "Phone" };

const KontakDarurat = () => {
  const { user } = useApp();
  const canEdit = user.role === "admin" || user.role === "super_admin";
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(emptyForm);

  const load = () => kontakAPI.list().then(setItems).catch(() => {});
  useEffect(() => { load(); }, []);

  const openNew = () => { setEditing(null); setForm(emptyForm); setOpen(true); };
  const openEdit = (k) => { setEditing(k); setForm({ nama: k.nama, nomor: k.nomor, kategori: k.kategori, icon: k.icon || "Phone" }); setOpen(true); };

  const submit = async () => {
    if (!form.nama || !form.nomor) { toast.error("Nama & nomor wajib"); return; }
    try {
      if (editing) { await kontakAPI.update(editing.id, form); toast.success("Kontak diperbarui"); }
      else { await kontakAPI.create(form); toast.success("Kontak ditambahkan"); }
      setOpen(false); load();
    } catch (e) { toast.error(e.response?.data?.detail || "Gagal"); }
  };

  const remove = async (id) => {
    if (!window.confirm("Hapus kontak ini?")) return;
    try { await kontakAPI.remove(id); toast.success("Dihapus"); load(); } catch (e) { toast.error(e.response?.data?.detail || "Gagal"); }
  };

  return (
    <div>
      <PageHeader title="Kontak Darurat" subtitle="Hubungi cepat saat situasi darurat" icon={PhoneCall}
        action={canEdit && (
          <Dialog open={open} onOpenChange={setOpen}>
            <Button className="brand-btn" onClick={openNew}><Plus className="h-4 w-4 mr-1" />Tambah Kontak</Button>
            <DialogContent><DialogHeader><DialogTitle>{editing ? "Edit Kontak" : "Tambah Kontak"}</DialogTitle></DialogHeader>
              <div className="space-y-3">
                <div><Label>Nama</Label><Input value={form.nama} onChange={(e) => setForm({ ...form, nama: e.target.value })} /></div>
                <div className="grid grid-cols-2 gap-3">
                  <div><Label>Nomor</Label><Input value={form.nomor} onChange={(e) => setForm({ ...form, nomor: e.target.value })} placeholder="0812-xxxx-xxxx" /></div>
                  <div><Label>Kategori</Label><Input value={form.kategori} onChange={(e) => setForm({ ...form, kategori: e.target.value })} /></div>
                </div>
                <div><Label>Icon</Label>
                  <Select value={form.icon} onValueChange={(v) => setForm({ ...form, icon: v })}>
                    <SelectTrigger><SelectValue /></SelectTrigger>
                    <SelectContent>{ICON_OPTIONS.map((i) => <SelectItem key={i} value={i}>{i}</SelectItem>)}</SelectContent>
                  </Select>
                </div>
              </div>
              <DialogFooter><Button variant="outline" onClick={() => setOpen(false)}>Batal</Button><Button onClick={submit} className="brand-btn">{editing ? "Simpan" : "Tambah"}</Button></DialogFooter>
            </DialogContent>
          </Dialog>
        )}
      />
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map((k) => {
          const Icon = ICON_MAP[k.icon] || Phone;
          return (
            <Card key={k.id} className="card-hover"><CardContent className="p-5">
              <div className="flex items-center gap-4">
                <a href={`tel:${k.nomor.replace(/[^0-9]/g, "")}`} className="h-14 w-14 rounded-2xl brand-gradient text-white grid place-items-center shadow-md shrink-0"><Icon className="h-6 w-6" /></a>
                <div className="flex-1 min-w-0"><div className="text-xs uppercase tracking-wide text-slate-500 font-semibold">{k.kategori}</div><div className="font-bold text-slate-800">{k.nama}</div><a href={`tel:${k.nomor.replace(/[^0-9]/g, "")}`} className="text-sm text-emerald-700 font-mono">{k.nomor}</a></div>
                {canEdit && <div className="flex flex-col"><Button size="sm" variant="ghost" onClick={() => openEdit(k)}><Edit3 className="h-4 w-4" /></Button><Button size="sm" variant="ghost" onClick={() => remove(k.id)} className="text-red-600 hover:text-red-700"><Trash2 className="h-4 w-4" /></Button></div>}
              </div>
            </CardContent></Card>
          );
        })}
      </div>
    </div>
  );
};
export default KontakDarurat;
